import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  normalizeReferralCode,
  readReferralFromSearch,
  storeReferralCode
} from '../utils/referral';

const ReferralRedirectPage = () => {
  const { code } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fromPath = normalizeReferralCode(code);
    const fromQuery = normalizeReferralCode(readReferralFromSearch(location.search));
    const resolvedCode = fromPath || fromQuery;

    if (resolvedCode) {
      storeReferralCode(resolvedCode);
    }

    navigate('/register', { replace: true, state: { ref: resolvedCode || '' } });
  }, [code, location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-200">
      Redirecting...
    </div>
  );
};

export default ReferralRedirectPage;
